Object.defineProperty(exports, "__esModule", {
    value: true
});
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var require_logger = require('../logger.cjs');
var require_tool = require('../tool.cjs');
var require_syncHook = require('./syncHook.cjs');
var require_syncWaterfallHook = require('./syncWaterfallHook.cjs');
//#region src/utils/hooks/asyncWaterfallHooks.ts
var AsyncWaterfallHook = /*#__PURE__*/ function(_require_syncHook_SyncHook) {
    "use strict";
    _inherits._(AsyncWaterfallHook, _require_syncHook_SyncHook);
    function AsyncWaterfallHook(type) {
        _class_call_check._(this, AsyncWaterfallHook);
        var _this;
        _this = _call_super._(this, AsyncWaterfallHook);
        _this.onerror = require_logger.error;
        _this.type = type;
        return _this;
    }
    _create_class._(AsyncWaterfallHook, [
        {
            key: "emit",
            value: function emit(data) {
                if (!require_tool.isObject(data)) require_logger.error(`The response data for the "${this.type}" hook must be an object.`);
                var ls = Array.from(this.listeners);
                if (ls.length > 0) {
                    var i = 0;
                    var processError = (e)=>{
                        require_logger.warn(e);
                        this.onerror(e);
                        return data;
                    };
                    var call = (prevData)=>{
                        if (require_syncWaterfallHook.checkReturnData(data, prevData)) {
                            data = prevData;
                            if (i < ls.length) try {
                                return Promise.resolve(ls[i++](data)).then(call, processError);
                            } catch (e) {
                                return processError(e);
                            }
                        } else this.onerror(`A plugin returned an incorrect value for the "${this.type}" type.`);
                        return data;
                    };
                    return Promise.resolve(call(data));
                }
                return Promise.resolve(data);
            }
        }
    ]);
    return AsyncWaterfallHook;
}(require_syncHook.SyncHook);
//#endregion
exports.AsyncWaterfallHook = AsyncWaterfallHook; //# sourceMappingURL=asyncWaterfallHooks.cjs.map
